import React from "react";
import PropTypes from "prop-types";
import Typography from "ui/Typography";

export const FormGroupTitle = (props) => {
  const { title } = props;
  return (
    <Typography variant="subtitle2" color="surface.onSurfaceVariant">
      {title}
    </Typography>
  );
};
FormGroupTitle.propTypes = {
  title: PropTypes.any,
};
